<template>
  <div class="page-content">
    <div class="sm">
      <el-row class="smTitle">
        <div style="height:45px;line-height:45px;">
          <!-- ../../assets/images/card-ticket/Shape@2x.png -->
          <img class="smImg"
               src="../../assets/images/card-ticket/Shape.png">
          <!-- <i class="el-icon-warning"></i> -->
          说明</div>
        <ul>
          <li>人群核销限制，用以配置卡券持有人，固定时间段内，可使用卡券数量上限</li>
          <li>卡券核销限制，用以配置卡券核销单位，如门店，经销商等，固定时间段内，可核销卡券的数量上限</li>
          <li>不填则表示不限制</li>
        </ul>
      </el-row>
    </div>
    <el-row class="search-title common-table-top">
      <el-col :span="4"
              style="text-align: left;">
        <i class="el-icon-document"
           style="font-weight: bold;"></i>
        <span class="order-list-search-span">核销设置</span>
      </el-col>
      <el-col :span="20"
              class="text-align-right">
      </el-col>
    </el-row>
    <el-row class="box-content">
      <div class=" form-content">
        <el-form :inline="true"
                 class="acivity-content-form"
                 ref="formInline"
                 :model="formInline"
                 :rules="rules"
                 label-width="280px">
          <div class="hx-xz">人群核销限制：</div>
          <el-form-item>
            <el-col :span="8"
                    class="cont-leftYz">
              <el-form-item prop="audiencesDays">
                <span class="first-Ts">每</span>
                <el-input placeholder=""
                          v-model.number="formInline.audiencesDays"
                          maxlength="99999999"></el-input><span> 天，</span>
              </el-form-item>
            </el-col>
            <el-col :span="9"
                    class="cont-leftYz cont-RightYz">
              <el-form-item prop="audiencesUpperLimit">
                <span class="first-Ts">限使用</span>
                <el-input placeholder=""
                          v-model.number="formInline.audiencesUpperLimit"
                          maxlength="99999999"></el-input>张
              </el-form-item>
            </el-col>
            <!-- <span class="cont-last"> </span> -->
          </el-form-item>
          <div class="hx-xz">卡券核销限制：</div>
          <el-form-item>
            <el-col :span="8"
                    class="cont-leftYz">
              <el-form-item prop="verifiedDays">
                <span class="first-Ts">每</span>
                <el-input placeholder=""
                          v-model.number="formInline.verifiedDays"
                          maxlength="99999999"></el-input><span> 天，</span>
              </el-form-item>
            </el-col>
            <el-col :span="9"
                    class="cont-leftYz cont-RightYz">
              <el-form-item prop="verifiedUpperLimit">
                <span class="first-Ts">限核销</span>
                <el-input placeholder=""
                          v-model.number="formInline.verifiedUpperLimit"
                          maxlength="99999999"></el-input>张
              </el-form-item>
            </el-col>
            <!-- <span class="cont-last"> </span> -->
          </el-form-item>
          <el-form-item class="button-content">
            <el-button class="dialog-confirm-btn"
                       type="primary"
                       v-show="btnType.save"
                       @click="propertySet">
              保存
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-row>
  </div>
</template>

<script>
import { findProperty, propertySet } from '@/api/cardTicket.js'
import { butonsList,getMenId } from '@/api/analyse.js'
export default {
  data () {
    var checkAge = (rule, value, callback) => {
      if (value === '') {
        callback()
      }
      setTimeout(() => {
        if (value <= 0) {
          callback(new Error('请输入大于0的数字'))
        }
        if (!Number.isInteger(value) && value != '' && value != undefined) {
          callback(new Error('请输入数字值'))
        } else if ((value <= 0 || value > 99999999) && value != '') {
          callback(new Error('请输入大于1小于99999999的数字'))
        } else {
          callback()
        }
      }, 200)
    }
    return {
      formInline: {
        id: '',
        audiencesDays: '',
        audiencesUpperLimit: '',
        verifiedDays: '',
        verifiedUpperLimit: ''
      },
      rules: {
        audiencesDays: [
          { validator: checkAge, trigger: 'blur' }
        ],
        audiencesUpperLimit: [
          { validator: checkAge, trigger: 'blur' }
        ],
        verifiedDays: [
          { validator: checkAge, trigger: 'blur' }
        ],
        verifiedUpperLimit: [
          { validator: checkAge, trigger: 'blur' }
        ]
      },
      btnType:{
        'save':false
      }
    }
  },
  methods: {
    getfindProperty () {
      findProperty().then(res => {
        console.log(res)
        if (res.data.result.id !== undefined) {
          this.formInline.id = res.data.result.id
          this.formInline.audiencesDays = res.data.result.audiencesDays
          this.formInline.audiencesUpperLimit = res.data.result.audiencesUpperLimit
          this.formInline.verifiedDays = res.data.result.verifiedDays
          this.formInline.verifiedUpperLimit = res.data.result.verifiedUpperLimit
        }
      })
    },
    queryBtnList(){
      var itemId = getMenId(this.$route.path)
       butonsList({systemCode: 'ZY_INTELLIQUOR',menuId:itemId})
        .then((res)=>{
          if(res.data.code == '200'){
            var btnList = this.btnType
            for(let i = 0, k = res.data.result.length; i < k; i ++){
              for(let m in btnList){
                if(res.data.result[i].perms.indexOf(m) != -1){
                  this.btnType[m] = true
                }
              }
            }
          }
        })
    },
    propertySet () {
      propertySet(this.formInline).then(res => {
        console.log(res)
        if (res.data.code === '200') {
          _g.toastMsg('success', '保存成功！')
        } else {
          _g.toastMsg('error', res.data.message)
        }

      })
    }
  },
  mounted () {
    this.getfindProperty()
    this.queryBtnList()
  }
}
</script>

<style scoped>
.form-content {
  background-color: #fff;
  width: 100%;
  height: 500px;
  text-align: center;
  display: flex;
  justify-content: left;
  flex-direction: row;
}
.cont-last {
  display: inline-block;
  width: 160px;
  margin-left: -29px;
}
.sm {
  margin: 0 24px 20px 24px;
  border-radius: 2px;
}
.smTitle {
  background: #fff;
  border-bottom: 1px solid #e7e7e7;
  line-height: 48px;
  font-size: 14px;
  color: #333;
}
.smTitle div {
  text-align: left;
  margin-left: 32px;
  height: 45px;
  line-height: 45px;
}

.smTitle ul li {
  text-align: left;
  height: 30px;
  line-height: 30px;
  color: #999999;
  margin-left: 24px;
}
.smImg {
  display: inline-block;
  width: 17px;
  height: 17px;
  vertical-align: middle;
}
.hx-xz {
  text-align: left;
  margin: 0 0 15px 36px;
}
</style>